import React, { useState } from 'react';

import { Confirmation, Information } from './common';
import { UserIntegrateTable } from '../tables/UserIntegrateTable';
import PrintUtility from '../../utilities/printUtility';
import StaticFileService from '../../services/StaticFiles';
import _ from 'lodash';
import { FILE_CODE } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

const downloadFile = showError => {
  const params = { file_code: 'integrateIntroduce' };
  PrintUtility.printOrOpenBlob(
    async () => {
      return StaticFileService.files(params).then(response => {
        if (_.includes(response.type, 'octet-stream')) {
          const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
          return new Blob([bom, response], { type: 'application/pdf' });
        } else {
          showError(true);
          return null;
        }
      });
    },
    'アカウントの統合について.pdf',
    FILE_CODE.PDF,
    false
  );
};

export const ConfirmIntegrateUserDialog = ({
  visible,
  onConfirm,
  onCancel,
  data,
  action,
  cancelButtonText = '統合をやめる',
  confirmButtonText = 'アカウントを統合する',
  title = 'アカウントを統合する',
}) => {
  const [classConfirm, setClassName] = useState('btn--effective btn--disabled');
  const [disabledConfirmButton, setDisabledConfirmButton] = useState(true);
  const [visibleDownloadErrorDialog, setVisibleDownloadErrorDialog] = useState(
    false
  );

  const handleOnchange = e => {
    if (!e.target.checked) {
      setDisabledConfirmButton(true);
      setClassName('btn--effective btn--disabled');
      return;
    }
    setDisabledConfirmButton(false);
    setClassName('btn--effective');
  };

  const getMessage = () => {
    return (
      <div>
        <div className='user-integrate__description'>
          アカウントを統合することで以下のことが可能になります。
          <br /> <br />
          <ul className='user-integrate__description--note'>
            <li>
              複数のアカウントに同じID（メールアドレス）とパスワードでログインする
            </li>
            <li>ログアウトすることなく複数のアカウントを切り替えて操作する</li>
          </ul>
          <br />
          <span className='user-integrate__description--strong'>
            なお、一度統合したアカウントは解除することができませんので、ご注意ください。
          </span>
          <br />
          <span>
            詳しくは
            <button
              className='btn-text--sm'
              onClick={() => downloadFile(setVisibleDownloadErrorDialog)}
            >
              アカウント統合についてのマニュアル
            </button>
            をご確認ください。
          </span>
          <br /> <br />
          以下のアカウントと統合してよろしいですか？
        </div>
        <UserIntegrateTable data={data} action={action} maxHeightTable={167} />
        <div className='confirm-integrate'>
          <label className='checkbox'>
            <input
              type='checkbox'
              onChange={e => handleOnchange(e)}
              id='confirm-integrate'
            />
            <i className='i-square i-3x' aria-hidden='true' />
            上記事項を確認し、アカウントを統合する
          </label>
        </div>
      </div>
    );
  };

  const handleOnCancel = async () => {
    await setClassName('btn--effective btn--disabled');
    await setDisabledConfirmButton(true);
    onCancel();
  };

  return (
    <React.Fragment>
      <Confirmation
        message={getMessage()}
        rootClassName='user-integrate'
        title={title}
        cancelButtonText={cancelButtonText}
        confirmButtonText={confirmButtonText}
        visible={visible}
        onCancel={handleOnCancel}
        onConfirm={onConfirm}
        disabledConfirmButton={disabledConfirmButton}
        effectiveButtonClassName={classConfirm}
      />
      <Information
        visible={visibleDownloadErrorDialog}
        title='ダウンロードエラー'
        message={messageUtility.getMessage('E-000-033')}
        buttonText={messageUtility.getMessage('I-000-008')}
        onClose={() => setVisibleDownloadErrorDialog(false)}
        buttonClassName='btn--sm--sub'
      />
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ConfirmIntegrateUserDialog.jsx